/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Vuelti durmiendo — empty states ("sin ventas hoy", lista vacía, sin datos).
 * Port del asset canónico `documentacion/design/brand/logo/vuelti-durmiendo.svg`
 * a react-native-svg (mismo patrón que VueltiFeliz).
 * Mantener la moneda orange en el brazo derecho (landmark).
 */
import React from 'react';
import { View } from 'react-native';
import Svg, { Circle, Ellipse, Path, Text as SvgText } from 'react-native-svg';

type Props = {
  /** Ancho en px (alto deriva del viewBox 200x240). Default 96. */
  size?: number;
  testID?: string;
};

export function VueltiDurmiendo({ size = 96, testID }: Props) {
  return (
    <View testID={testID} accessible={false}>
      <Svg width={size} height={(size * 240) / 200} viewBox="0 0 200 240">
        <Path d="M155 120 Q172 135 175 150" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
        <Circle cx={177} cy={153} r={14} fill="#D97745" stroke="#115E59" strokeWidth={2} opacity={0.7} />
        <SvgText x={177} y={158} fontFamily="sans-serif" fontSize={13} fontWeight="700" fill="#FFFFFF" textAnchor="middle">$</SvgText>
        {/* transform SVG nativo: `origin` se traduce a DOM prop 'transform-origin' (kebab) en web y React lo rechaza. */}
        <Ellipse cx={100} cy={120} rx={62} ry={68} fill="#0F766E" transform="rotate(-5 100 120)" />
        <Ellipse cx={82} cy={90} rx={22} ry={14} fill="#0D9488" opacity={0.4} />
        <Path d="M45 125 Q28 145 30 165" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
        <Circle cx={28} cy={168} r={9} fill="#0F766E" />
        <Path d="M80 185 Q75 200 78 215 M120 185 Q125 200 122 215" fill="none" stroke="#0F766E" strokeWidth={7} strokeLinecap="round" />
        <Ellipse cx={78} cy={218} rx={12} ry={6} fill="#115E59" />
        <Ellipse cx={122} cy={218} rx={12} ry={6} fill="#115E59" />
        <Path d="M70 105 Q80 110 90 105 M110 105 Q120 110 130 105" fill="none" stroke="#1C1917" strokeWidth={4} strokeLinecap="round" />
        <Ellipse cx={100} cy={138} rx={5} ry={7} fill="#1C1917" />
        <SvgText x={145} y={80} fontFamily="sans-serif" fontSize={14} fontWeight="700" fill="#0D9488" opacity={0.7}>z</SvgText>
        <SvgText x={155} y={65} fontFamily="sans-serif" fontSize={18} fontWeight="700" fill="#0D9488" opacity={0.7}>z</SvgText>
        <SvgText x={168} y={48} fontFamily="sans-serif" fontSize={22} fontWeight="700" fill="#0D9488" opacity={0.7}>Z</SvgText>
      </Svg>
    </View>
  );
}
